/// <amd-module name="Build/Admin/AgentCloudsList/AgentCloudsListView" />
import * as React from "react";

import { IVssComponentContext, IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";
import { IVssPerformanceService } from "VSS/Platform/Performance";

import { AgentCloudsHub } from "Build/Admin/AgentCloudsList/Components/AgentCloudsHub";
import { Flux } from "Build/Admin/AgentCloudsList/Flux";
import { Telemetry } from "Build/Admin/Common/Constants";

export class AgentCloudsListView extends VssComponent<IVssComponentProperties> {
    private _flux: Flux;
    private _ttiMarked: boolean = false;

    constructor(props: IVssComponentProperties, context: IVssComponentContext) {
        super(props, context);
        this._flux = new Flux(context.pageContext);
        this._flux.agentCloudsListActionCreator.initializeAgentClouds();
    }

    public componentDidMount(): void {
        if (!this._ttiMarked) {
            this.context.pageContext.getService<IVssPerformanceService>("IVssPerformanceService").markTimeToInteractive(Telemetry.Area, Telemetry.AgentCloudsView);
            this._ttiMarked = true;
        }
    }

    public render(): JSX.Element {
        return (
            <AgentCloudsHub
                actionCreator={this._flux.agentCloudsListActionCreator}
                storesHub={this._flux.storesHub} />
        );
    }
}

VssComponent.register("ms.vss-build-web.admin-agent-clouds-list-view-component", AgentCloudsListView);
